import React from 'react';
import { Box, TextField } from '@mui/material';

import { CustomEditorProps } from '.';

const PlainTextEditor: React.FC<CustomEditorProps> = ({ value, onChange, readonly }) => {
  return (
    <Box>
      {readonly ? (
        <Box sx={{ background: '#fafafa', p: 2, borderRadius: 1 }}>{value}</Box>
      ) : (
        <TextField
          value={value || ''}
          onChange={e => onChange && onChange(e.target.value)}
          fullWidth
          multiline
          rows={6}
        />
      )}
    </Box>
  );
};
export default PlainTextEditor;
